import { del, get, patch, post } from '@elementary/common-ui/utils/http';
import { ATLAN_API_KEY_PLACEHOLDER } from 'shared/constants';
import { AtlanIntegrationForm, AtlanIntegrationResponse } from 'shared/types';

const getPayload = ({ baseUrl, apiKey }: AtlanIntegrationForm) => ({
  base_url: baseUrl,
  ...(apiKey &&
    apiKey !== ATLAN_API_KEY_PLACEHOLDER && {
      api_key: apiKey,
    }),
});

export const fetchAtlanIntegration = (
  envId: string,
): Promise<AtlanIntegrationResponse> =>
  get(`${import.meta.env.VITE_API_BASE_URL}/settings/${envId}/atlan`);

export const testAtlanIntegration = (
  envId: string,
  data: AtlanIntegrationForm,
): Promise<void> =>
  post(
    `${import.meta.env.VITE_API_BASE_URL}/settings/${envId}/atlan/test`,
    getPayload(data),
  );

export const createAtlanIntegration = (
  envId: string,
  data: AtlanIntegrationForm,
): Promise<AtlanIntegrationResponse> =>
  post(
    `${import.meta.env.VITE_API_BASE_URL}/settings/${envId}/atlan`,
    getPayload(data),
  );

export const updateAtlanIntegration = (
  envId: string,
  data: AtlanIntegrationForm,
): Promise<AtlanIntegrationResponse> =>
  patch(
    `${import.meta.env.VITE_API_BASE_URL}/settings/${envId}/atlan`,
    getPayload(data),
  );

export const deleteAtlanIntegration = (envId: string): Promise<void> =>
  del(`${import.meta.env.VITE_API_BASE_URL}/settings/${envId}/atlan`);
